"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeInvitations_de_de = void 0;
function backofficeInvitations_de_de() {
    return {
        "backoffice.invitations.invitedialog.title": "Einladung versenden",
        "backoffice.invitations.invitedialog.company": "Firmen Rollen",
        "backoffice.invitations.invitedialog.projects": "Projekt Rollen",
        "backoffice.invitations.invitedialog.email": "E-Mail",
        "backoffice.invitations.invitedialog.companypermissions": "Berechtigungen",
        "backoffice.invitations.invitedialog.projectpermissions": "Berechtigungen",
        "backoffice.invitations.invitedialog.roles": "Rollen",
        "backoffice.invitations.invitedialog.invite": "Einladen",
        "backoffice.invitations.invitedialog.noprojectsfound": "Es gibt keine Projekte zu welchen Benutzer eingeladen werden könnten!",
        "backoffice.invitations.invitedialog.addprojectpermission": "Projektberechtigungen hinzufügen",
        "backoffice.invitations.invitedialog.chooseproject": "Projekt auswählen",
        "backoffice.invitations.invitedialog.noprojectroles": "Es existieren keine Projektrollen. Es muss mindestens eine Projektrolle erstellt werden, damit eine Einladung verschickt werden kann.",
        "backoffice.invitations.invitedialog.nocompanyroles": "Es existieren keine Firmenrollen. Es muss mindestens eine Firmenrolle erstellt werden, damit eine Einladung verschickt werden kann.",
        "backoffice.invitations.invitedialog.createrole": "Rolle erstellen",
        "backoffice.invitations.messages.currentlyaccepting": "Einladung wird akzeptiert...",
        "backoffice.invitations.messages.successtitle": "Einladung akzeptiert",
        "backoffice.invitations.messages.successmessage": "Die Einladung wurde erfolgreich akzeptiert. Wohin dürfen wir Sie weiterleiten?",
        "backoffice.invitations.messages.gotoproject": "Gleich zum Projekt",
        "backoffice.invitations.errors.400": "Dieser Einladungslink ist ungültig!",
        "backoffice.invitations.errors.404": "Dieser Einladungslink ist ungültig!",
        "backoffice.invitations.errors.alreadyused": "Dieser Einladungslink wurde schon benutzt!"
    };
}
exports.backofficeInvitations_de_de = backofficeInvitations_de_de;
